/** Creating a shop from the sign-in page. */
const signup = {
  en: {
    link: "New here? Create your shop",
    title: "Create your shop",
    invitedBy: "{name} invited you. Once you and they have each paid a month, both shops get one month free.",
    subtitle: "Free trial, no card needed. You can start selling in minutes.",
    closed: "Signup is not open yet. Please check back soon.",
    ownerName: "Your name",
    email: "Email address",
    phone: "Phone number",
    phoneHint: "We may call or WhatsApp you to help you get started.",
    password: "Choose a password",
    passwordHint: "At least 8 characters.",
    confirmPassword: "Confirm your password",
    passwordMismatch: "The two passwords are not the same.",
    shopName: "Shop name",
    currency: "Currency",
    chooseLink: "Choose your shop's link",
    linkHint: "Customers reach your menu at this address. Leave it empty and we will pick one from your shop's name.",
    linkLabel: "Link",
    terms: "I accept the {terms} and the {privacy}.",
    termsLink: "terms of service",
    privacyLink: "privacy policy",
    submit: "Create my shop",
    submitting: "Creating your shop…",
    haveAccount: "Already have an account? Sign in",
    emailTaken: "This email address already has an account.",
    phoneTaken: "This phone number already has an account.",
    slugTaken: "That link is not available. Choose another.",
    mustAccept: "Please accept the terms to continue.",
    failed: "We could not create your shop. Check the details and try again.",
    tooMany: "Too many attempts. Please wait a while and try again.",
    botCheck: "The check failed. Reload the page and try again.",
  },
  fr: {
    link: "Nouveau ? Créez votre boutique",
    title: "Créez votre boutique",
    invitedBy: "{name} vous a invité. Quand vous et cette boutique aurez chacun payé un mois, les deux boutiques recevront un mois offert.",
    subtitle: "Essai gratuit, sans carte bancaire. Vous pouvez commencer à vendre en quelques minutes.",
    closed: "Les inscriptions ne sont pas encore ouvertes. Revenez bientôt.",
    ownerName: "Votre nom",
    email: "Adresse e-mail",
    phone: "Numéro de téléphone",
    phoneHint: "Nous pourrons vous appeler ou vous écrire sur WhatsApp pour vous aider à démarrer.",
    password: "Choisissez un mot de passe",
    passwordHint: "Au moins 8 caractères.",
    confirmPassword: "Confirmez votre mot de passe",
    passwordMismatch: "Les deux mots de passe ne sont pas identiques.",
    shopName: "Nom de la boutique",
    currency: "Devise",
    chooseLink: "Choisissez le lien de votre boutique",
    linkHint: "Vos clients accèdent à votre menu à cette adresse. Laissez vide et nous en choisirons un à partir du nom de votre boutique.",
    linkLabel: "Lien",
    terms: "J'accepte les {terms} et la {privacy}.",
    termsLink: "conditions d'utilisation",
    privacyLink: "politique de confidentialité",
    submit: "Créer ma boutique",
    submitting: "Création de votre boutique…",
    haveAccount: "Vous avez déjà un compte ? Connectez-vous",
    emailTaken: "Cette adresse e-mail a déjà un compte.",
    phoneTaken: "Ce numéro de téléphone a déjà un compte.",
    slugTaken: "Ce lien n'est pas disponible. Choisissez-en un autre.",
    mustAccept: "Veuillez accepter les conditions pour continuer.",
    failed: "Impossible de créer votre boutique. Vérifiez les informations et réessayez.",
    tooMany: "Trop de tentatives. Patientez un moment et réessayez.",
    botCheck: "La vérification a échoué. Rechargez la page et réessayez.",
  },
  ar: {
    link: "جديد هنا؟ أنشئ متجرك",
    title: "أنشئ متجرك",
    invitedBy: "دعاك {name}. عندما يدفع كلٌّ منكما شهرًا، يحصل المتجران على شهر مجاني.",
    subtitle: "تجربة مجانية دون بطاقة بنكية. يمكنك البدء بالبيع خلال دقائق.",
    closed: "التسجيل غير مفتوح بعد. عُد قريبًا.",
    ownerName: "اسمك",
    email: "البريد الإلكتروني",
    phone: "رقم الهاتف",
    phoneHint: "قد نتصل بك أو نراسلك عبر واتساب لمساعدتك على البدء.",
    password: "اختر كلمة مرور",
    passwordHint: "8 أحرف على الأقل.",
    confirmPassword: "أكّد كلمة المرور",
    passwordMismatch: "كلمتا المرور غير متطابقتين.",
    shopName: "اسم المتجر",
    currency: "العملة",
    chooseLink: "اختر رابط متجرك",
    linkHint: "يصل زبائنك إلى قائمتك عبر هذا العنوان. اتركه فارغًا وسنختار لك رابطًا من اسم متجرك.",
    linkLabel: "الرابط",
    terms: "أوافق على {terms} و{privacy}.",
    termsLink: "شروط الاستخدام",
    privacyLink: "سياسة الخصوصية",
    submit: "إنشاء متجري",
    submitting: "جارٍ إنشاء متجرك…",
    haveAccount: "لديك حساب؟ سجّل الدخول",
    emailTaken: "هذا البريد الإلكتروني لديه حساب بالفعل.",
    phoneTaken: "رقم الهاتف هذا لديه حساب بالفعل.",
    slugTaken: "هذا الرابط غير متاح. اختر رابطًا آخر.",
    mustAccept: "يُرجى قبول الشروط للمتابعة.",
    failed: "تعذّر إنشاء متجرك. تحقق من البيانات وحاول مرة أخرى.",
    tooMany: "محاولات كثيرة. انتظر قليلًا ثم حاول مرة أخرى.",
    botCheck: "فشل التحقق. أعد تحميل الصفحة وحاول مرة أخرى.",
  },
};

export default signup;
